import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'
import useToggleSdkContext from 'utils/useToogleSdk'
import { usePSStatus } from 'app/KinerjaPSPegawaiPage/hooks/useSummary'

import type { PenetapanPegawaiState } from 'types/kinerja-ps-pegawai'

interface CardPenetapanTahunanResultProps {
  status?: PenetapanPegawaiState
  year: number
  actionPath: string
}

export default function CardPenetapanTahunanResult({
  status: providedStatus,
  year,
  actionPath,
}: CardPenetapanTahunanResultProps) {
  const toggle = useToggleSdkContext()

  const isPenetapanEnabled =
    toggle?.['kinerja-ps-pegawai-penetapan-enabled'] || false

  const isPenetapanStatusProvided = React.useMemo(() => {
    return Boolean(providedStatus)
  }, [providedStatus])
  const { summary, summaryFetchStatus } = usePSStatus({
    disabled: !isPenetapanEnabled || isPenetapanStatusProvided,
  })
  const status = React.useMemo(() => {
    if (isPenetapanStatusProvided) {
      return providedStatus
    }
    return summary?.penetapanStatus
  }, [isPenetapanStatusProvided, providedStatus, summary?.penetapanStatus])

  if (
    !isPenetapanEnabled ||
    (!isPenetapanStatusProvided && summaryFetchStatus !== 'success') ||
    !['SENDING_TO_BKN', 'SENT_TO_BKN', 'ERROR_SEND'].includes(status)
  ) {
    return null
  }

  return (
    <Card className="p-6 !bg-gradient-to-r from-blue-90 to-blue-80 overflow-hidden w-full">
      <img
        alt=""
        role="presentation"
        src={assetUrl('/images/pengelolaan-kinerja/confetti.png')}
        className="absolute top-0 right-0 z-0"
        height={60}
        width={144}
      />
      <div className="flex items-center gap-6">
        <div className="flex-shrink-0">
          <Image
            alt=""
            src="/illustrations/img-reflection-documents-magnifying-glass.png"
            width={84}
            height={84}
          />
        </div>
        <div className="z-10 justify-between gap-6 space-y-4 lg:flex grow lg:space-y-0">
          <div className="flex flex-col items-start justify-center flex-1 gap-1">
            <div className="flex flex-col items-start gap-2">
              <Text variant="subheading" color="inverse">
                HASIL PENILAIAN KINERJA
              </Text>
              <Text variant="heading-lg" color="inverse">
                Predikat Kinerja Tahun {year}
              </Text>
            </div>
          </div>
          <div className="z-10 w-60">
            <Link href={actionPath} passHref>
              <Button size="lg" as="a" color="white" fullWidth>
                <Text className="!text-interactive-default" variant="action">
                  Cek
                </Text>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Card>
  )
}
